import { render } from "./MyDepartment.vue?vue&type=template&id=e50ead6a&scoped=true"
import script from "./MyDepartment.vue?vue&type=script&lang=js"
export * from "./MyDepartment.vue?vue&type=script&lang=js"

import "./MyDepartment.vue?vue&type=style&index=0&id=e50ead6a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e50ead6a"]])

export default __exports__